module.exports = __webpack_public_path__ + "img/amex_logo.eb2d6d63.svg";